var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 2.75L3.6665 8.25V19.25H18.3332V8.25L10.9998 2.75ZM11.4582 11.4583C11.4582 12.2192 10.844 12.8333 10.0832 12.8333V16.5H9.1665V12.8333C8.40567 12.8333 7.7915 12.2192 7.7915 11.4583V8.70833H8.70817V11.4583H9.1665V8.70833H10.0832V11.4583H10.5415V8.70833H11.4582V11.4583ZM13.7498 16.5H12.8332V13.2917H11.9165V10.5417C11.9165 9.53333 12.7415 8.70833 13.7498 8.70833V16.5Z",
    fill: "#29ae00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#29ae00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveOrder);
export default __webpack_public_path__ + "static/media/active-order.468f702e39f507ad732df359642e7cb0.svg";
export { ForwardRef as ReactComponent };